// Vibhags Data - 18 Departments (Final List Based on Available Logos)
import swayamRojgarLogo from '../../assets/vibhag-logos/swayam-rojgar.png';
import vivahSanskarLogo from '../../assets/vibhag-logos/vivah-sanskar.png';
import itLogo from '../../assets/vibhag-logos/it.png';
import parayvanLogo from '../../assets/vibhag-logos/parayvan.png';
import krushiLogo from '../../assets/vibhag-logos/krushi-s.png';
import pashuGowanshLogo from '../../assets/vibhag-logos/pashu-gowansh.png';
import kaydeshirLogo from '../../assets/vibhag-logos/kaydeshir-vibhag.png';
import vastuLogo from '../../assets/vibhag-logos/vastu-shastra.png';
import balsanskarLogo from '../../assets/vibhag-logos/balsanskar-vibhag.png';
import yuvaPrabodhanLogo from '../../assets/vibhag-logos/yuva-prabodhan.png';
import ayurvedLogo from '../../assets/vibhag-logos/ayurved-vibhag.png';
import prashikshanLogo from '../../assets/vibhag-logos/prashikshan.png';
import marathiAsmitaLogo from '../../assets/vibhag-logos/marathi-asmita.png';
import prashnottarLogo from '../../assets/vibhag-logos/prashnottar-vibhag.png';
import vedVidnyanLogo from '../../assets/vibhag-logos/ved-vidnyan.png';
import deshVideshLogo from '../../assets/vibhag-logos/desh-videsh-.png';
import prashasakiyaLogo from '../../assets/vibhag-logos/prashasakiya-vibhag.png';
import garbhsanskarLogo from '../../assets/vibhag-logos/garbhsanskar.png';

export const vibhagsData = [
  

  {
    id: 1,
    name: {
      marathi: "बालसंस्कार विभाग",
      english: "Child Development Department"
    },
    icon: balsanskarLogo,
    category: "Education",
    color: "#FF6B35",
    description: {
      points: [
        "Creating creative and cultured generation",
        "Character, morality, character development through value education",
        "Increasing self-confidence and mental strength; respect for parents-teachers-country",
        "Environmental education and kitchen garden (organic/natural farming)",
        "Legal awareness, arts, sports, skill development",
        "Stotra-mantra recitation and science awareness behind it",
        "Introduction to Rishi-Muni research and good concepts",
        "Parent meetings, winter/summer camp organization",
        "Competitive exam and interview guidance and training",
        "Free service by trained representatives department-wise"
      ]
    },
    descriptionMarathi: {
      points: [
        "सृजनशील व सुसंस्कृत पिढी घडविणे",
        "मूल्यशिक्षणातून संस्कार, नैतिकता, चारित्र्य संवर्धन",
        "आत्मबल-मनोबल वाढ; पालक-शिक्षक-देशाविषयी आदर",
        "पर्यावरण शिक्षण व परसबाग (सेंद्रिय/नैसर्गिक शेती)",
        "कायदा-जागृती, कला, क्रीडा, कौशल्य विकास",
        "स्तोत्र-मंत्र पठण व त्यामागचे विज्ञान जागृती",
        "ऋषीमुनींच्या संशोधनाची ओळख व सुसंकल्प",
        "पालकसभा, हिवाळी/उन्हाळी शिबिरे आयोजन",
        "स्पर्धा परीक्षा व मुलाखत मार्गदर्शन व प्रशिक्षण",
        "प्रशिक्षित प्रतिनिधींकडून विभागनिहाय विनामूल्य सेवा"
      ]
    },
    motto: "शिक्षा ही सर्वोत्तम सेवा - Education is the best service"
  },

   {
    id: 2,
    name: {
      marathi: "गर्भसंस्कार व पालकत्व विभाग",
      english: "Prenatal Development & Parenting Department"
    },
    icon: garbhsanskarLogo,
    category: "Education",
    color: "#DC2626",
    description: {
      points: [
        "Sanskar is an effective direction to take the new generation on the path of meaningful progress; when started during pregnancy, it is called Garbh Sanskar",
        "Garbh Sanskar is not just mental but also useful for physical and intellectual development of the baby in the womb",
        "Shri Gurupith organizes counseling and seminar sessions nationwide",
        "Publication of books and videos, blogs on prenatal care and parenting techniques"
      ]
    },
    descriptionMarathi: {
      points: [
        "संस्कार ही नवी पिढीला प्रगतीच्या अर्थपूर्ण मार्गावर नेण्याची प्रभावी दिशा; गर्भावस्थेतच सुरुवात केली तर त्याला गर्भसंस्कार म्हणतात.",
        "गर्भसंस्कार हे फक्त मानसिक नाही तर गर्भातील बाळाच्या शारीरिक व बौद्धिक विकासासाठीही उपयुक्त.",
        "श्री गुरुपीठ देशभर समुपदेशन व सेमिनार सत्रांचे आयोजन",
        "प्रसूतीपूर्व काळजी व पालकत्व तंत्रांवर पुस्तके व व्हिडीओ, ब्लॉग्स प्रकाशन."
      ]
    },
    motto: "गर्भ संस्कारो हि श्रेष्ठः - Prenatal development is supreme"
  },

  {
    id: 3,
    name: {
      marathi: "युवा प्रबोधन विभाग",
      english: "Youth Awareness Department"
    },
    icon: yuvaPrabodhanLogo,
    category: "Education",
    color: "#FF6B35",
    description: {
      points: [
        "Lack of values; stress, depression, addiction, suicide among youth",
        "Service path: Discipline, restraint, unity, service, affection value promotion",
        "Free guidance and skill development for drug/addiction-free life",
        "Career, competitive exam, interview skill guidance - free",
        "3.5 km human chain; thousands of youth taking oath for addiction-free life"
      ]
    },
    descriptionMarathi: {
      points: [
        "मूल्यांचा अभाव; तरुणांमध्ये ताण, नैराश्य, व्यसन, आत्महत्या",
        "सेवामार्ग: शिस्त, संयम, ऐक्य, सेवा, ममत्व मूल्यसंवर्धन",
        "ड्रग्ज/व्यसनमुक्त जीवनासाठी मोफत मार्गदर्शन व कौशल्य-विकास",
        "करिअर, स्पर्धा परीक्षा, मुलाखत कौशल्य मार्गदर्शन – विनामूल्य",
        "३.५ किमी मानवी साखळी; हजारो तरुणांची व्यसनमुक्तीची शपथ"
      ]
    },
    motto: "युवा शक्ति राष्ट्र शक्ति - Youth power is national power"
  },

  {
    id: 4,
    name: {
      marathi: "प्रश्नोत्तरे विभाग",
      english: "Questions & Answers Department"
    },
    icon: prashnottarLogo,
    category: "Spiritual",
    color: "#3B82F6",
    description: {
      points: [
        "Spiritual guidance on worldly and spiritual problems",
        "Remedies, counseling and sadhana-suggestions according to personal problems",
        "Trained service workers available at each service center under training department",
        "Free service: Continuous help for suffering, distressed, afflicted",
        "Trying to solve problems with compassion and dedication",
        "Guidance on scriptural sadhana, rules and conduct",
        "Confidentiality, sympathy and result-oriented approach",
        "Planned sessions and counseling along with direct meetings",
        "Continuous, uninterrupted service for social welfare"
      ]
    },
    descriptionMarathi: {
      points: [
        "प्रापंचिक व पारमार्थिक समस्यांवर आध्यात्मिक मार्गदर्शन",
        "वैयक्तिक समस्यांनुसार उपाय, समुपदेशन व साधना-सूचना",
        "प्रशिक्षण विभागांतर्गत प्रशिक्षित सेवेकरी प्रत्येक सेवाकेंद्रात उपलब्ध",
        "विनामूल्य सेवा: दु:खी, आर्त, पीडितांसाठी सतत सहाय्य",
        "करुणाभावाने, जिवात जीव घालून समस्या निवारणाचा प्रयत्न",
        "शास्त्रोक्त साधना, नियम व आचरणावर मार्गदर्शन",
        "गोपनीयता, सहानुभूती व परिणामाभिमुख दृष्टिकोन",
        "प्रत्यक्ष भेटीबरोबर नियोजित सत्रे व समुपदेशन",
        "समाजहितासाठी सातत्यपूर्ण, अखंडित सेवा"
      ]
    },
    motto: "ज्ञानं परमं बलं - Knowledge is the ultimate strength"
  },

   {
    id: 5,
    name: {
      marathi: "माहिती व तंत्रज्ञान विभाग",
      english: "Information & Technology Department"
    },
    icon: itLogo,
    category: "Technology",
    color: "#0EA5E9",
    description: {
      title: "Spreading service work through modern tools",
      points: [
        "Reaching information and programs of all departments to everyone",
        "Study of ancient sciences and texts, bridging science-spirituality",
        "Cyber security and awareness about new frauds"
      ]
    },
    descriptionMarathi: {
      title: "आधुनिक साधनांनी सेवा कार्याचा प्रसार:",
      points: [
        "सर्व विभागांची माहिती व उपक्रम सर्वांपर्यंत पोहोचवणे",
        "प्राचीन शास्त्रे व ग्रंथांचा अभ्यास, विज्ञान-आध्यात्मिक सांगड",
        "सायबर सुरक्षा व नवनवीन फसवणुकीपासून जनजागृती"
      ]
    },
    motto: "तंत्रज्ञानं सर्वोत्तमं - Technology is the best"
  },

   {
    id: 6,
    name: {
      marathi: "विवाह संस्कार विभाग",
      english: "Marriage & Rituals Department"
    },
    icon: vivahSanskarLogo,
    category: "Cultural",
    color: "#EC4899",
    description: {
      title: "Programs for modern society while preserving Indian culture",
      points: [
        "1.5 lakh+ bride-groom registrations",
        "150+ mass marriage ceremonies annually",
        "Representatives working in 12 states and 4 countries",
        "Pre and post-marriage counseling",
        "Free marriages for children of suicide-affected farmers and martyred soldiers",
        "Eradication of evil practices and dowry system"
      ]
    },
    descriptionMarathi: {
      title: "भारतीय संस्कृती जपत आधुनिक समाजासाठी उपक्रम:",
      points: [
        "1.5 लाख+ वरवधूंची नावनोंदणी",
        "दरवर्षी 150+ सामूहिक विवाह सोहळे",
        "12 राज्ये व 4 देशांत कार्यरत प्रतिनिधी",
        "विवाहपूर्व व विवाहोत्तर समस्यांवर समुपदेशन",
        "आत्महत्याग्रस्त शेतकरी व शहीद जवानांच्या मुलामुलींचे मोफत विवाह",
        "अनिष्ट प्रथा व हुंडा प्रथा निर्मूलन"
      ]
    },
    motto: "विवाहो धर्मः - Marriage is a sacred duty"
  },

  {
    id: 7,
    name: {
      marathi: "आरोग्य व आयुर्वेद विभाग",
      english: "Health & Ayurveda Department"
    },
    icon: ayurvedLogo,
    category: "Health",
    color: "#10B981",
    description: {
      points: [
        "Disease prevention by combining spirituality + Ayurveda",
        "Integrated treatment approach for incurable diseases",
        "Cultivation and research of rare medicinal herbs",
        "Alternative remedies for incurable diseases",
        "Reaching Ayurvedic knowledge to the public free of cost",
        "Free medical camps at Shri Gurupith Tryambakeshwar",
        "Women's, children's and elderly health check-up programs",
        "Dental, oral, eye, kidney and Ayurvedic check-up facilities",
        "Regular blood donation camps and health awareness",
        "Guidance on Panchakarma and traditional treatments",
        "Free benefit schemes for countless needy"
      ]
    },
    descriptionMarathi: {
      points: [
        "अध्यात्म + आयुर्वेद जोडून रोगनिवारण",
        "दुर्धर आजारांसाठी समन्वित उपचार मार्ग",
        "दुर्मिळ वनौषधी लागवड व संशोधन",
        "आसाध्य व्याधींवरील अनुपयोगीपणाला पर्याय उपाय",
        "आयुर्वेदाचे ज्ञान जनतेपर्यंत विनामूल्य पोचवणे",
        "श्री गुरुपीठ त्र्यंबकेश्वर येथील मोफत वैद्यकीय शिबिरे",
        "स्त्रीरोग, बालक व वृद्धत्व तपासणी उपक्रम",
        "दंत, मुख, नेत्र, किडनी व आयुर्वेद तपासणी सुविधा",
        "नियमित रक्तदान शिबिरे व आरोग्य जनजागृती",
        "पंचकर्म व पारंपरिक उपचारांचे मार्गदर्शन",
        "असंख्य गरजूंसाठी निःशुल्क लाभ योजना"
      ]
    },
    motto: "स्वस्थं सर्वार्थसाधनं - Health is the foundation of all achievements"
  },

  {
    id: 8,
    name: {
      marathi: "कृषि शास्त्र विभाग",
      english: "Agricultural Science Department"
    },
    icon: krushiLogo,
    category: "Agriculture",
    color: "#F59E0B",
    description: {
      title: "Bridging spirituality and science for farmers' excellent programs",
      points: [
        "1800+ agricultural representatives across Maharashtra and 6 states",
        "350+ farmer training workshops",
        "Free distribution of bio-culture to 3.15 lakh farmers",
        "Training for 250+ processing industries and allied businesses",
        "Establishment of 750+ farmer groups",
        "Collection of 750 Sonali indigenous seeds in Shakambhari Seed Bank",
        "Reaching 8 to 10 lakh farmers"
      ],
      special: "Special programs: Global Agriculture Festival (15 years running), Krushidhan - farmers' own brand"
    },
    descriptionMarathi: {
      title: "अध्यात्म आणि विज्ञानाची सांगड घालत शेतकऱ्यांसाठी उत्कृष्ट उपक्रम:",
      points: [
        "महाराष्ट्रासह 6 राज्यांमध्ये 1800+ कृषी प्रतिनिधी",
        "350+ शेतकरी प्रशिक्षण कार्यशाळा",
        "3 लाख 15 हजार शेतकऱ्यांना मोफत जिवाणू कल्चर वाटप",
        "250+ प्रक्रिया उद्योग व जोड व्यवसायांचे प्रशिक्षण",
        "750+ शेतकरी गटांची स्थापना",
        "शाकंभरी सीड बँकेत 750 सोनाली देशी बीजांचे संकलन",
        "8 ते 10 लाख शेतकऱ्यांपर्यंत पोहोच"
      ],
      special: "विशेष उपक्रम: जागतिक कृषी महोत्सव (15 वर्षे सुरू), कृषिधन हा शेतकऱ्यांचा स्वतःचा ब्रँड."
    },
    motto: "कृषिरेव कृष्णः - Agriculture is divine"
  },
  
  {
    id: 9,
    name: {
      marathi: "पशु गोवंश विभाग",
      english: "Animal & Cattle Department"
    },
    icon: pashuGowanshLogo,
    category: "Animal Welfare",
    color: "#CA8A04",
    description: {
      points: [
        "Protection and conservation of indigenous cows and cattle",
        "Medicinal uses of indigenous cow's milk and ghee, cow urine, Panchagavya",
        "Biogas (methane) production from cow dung",
        "Spiritual environment and nutrition of cows through Homa-Havan mantra treatment",
        "Demonstrations for cow conservation through scientific and spiritual methods",
        "Workshops and camps on fodder management, hydroponics, silage/grass",
        "Training in preparation of cow dung products"
      ]
    },
    descriptionMarathi: {
      points: [
        "देशी गाई व गोवंशाचे संरक्षण व संवर्धन",
        "देशी गाईंचे दूध व तुप, गोमूत्र, पंचगव्य आदींचे औषधी उपयोग",
        "गोमयापासून बायोगॅस (मीथेन) निर्मिती",
        "अध्यात्मिक वातावरण व होम-हवन मंत्रोपचारांनी गाईंचे पोषण",
        "वैज्ञानिक व आध्यात्मिक पद्धतीने गोसंवर्धनासाठी प्रात्यक्षिके",
        "चारा व्यवस्थापन, हायड्रोपोनिक्स, सायलज/मुरघास यांवर शिबिरे व कार्यशाळा.",
        "गोमय उत्पादने तयार करण्याचे प्रशिक्षण"
      ]
    },
    motto: "पशु सेवा परम धर्मः - Animal service is the highest duty"
  },
  {
    id: 10,
    name: {
      marathi: "भारतीय संस्कृती व अस्मिता विभाग",
      english: "Indian Culture & Identity Department"
    },
    icon: marathiAsmitaLogo,
    category: "Cultural",
    color: "#8B5CF6",
    description: {
      points: [
        "Cultural presentation of festivals and observances throughout the year",
        "Simple, easy language and demonstrations for year-round worship",
        "Spiritual and scientific importance guidance",
        "Kuldev-Kuldevi worship according to family traditions",
        "Guidance on specific rangoli patterns according to days",
        "Guidelines on how devghar-devhara should be",
        "Clear difference between right and wrong methods",
        "Life impact: guidance on appropriate-inappropriate behavior",
        "Service of working engineer and Vastu expert mothers-sisters"
      ]
    },
    descriptionMarathi: {
      points: [
        "सण-वार, व्रत-वैकल्यांचे संस्कृतिपूर्ण सादरीकरण",
        "वर्षभर मांडणी-पूजा: सुलभ, सोपी भाषा व प्रात्यक्षिके",
        "आध्यात्मिक व वैज्ञानिक महत्त्वाचे मार्गदर्शन",
        "कुलाचारानुसार कुलदैवत-कुलदेवी मानसंमान",
        "वारानुरूप विशिष्ट रांगोळ्या मार्गदर्शन",
        "देवघर-देव्हारा कसा असावा याचे संकेत",
        "सुयोग्य व चुकीची पद्धतीचा स्पष्ट फरक",
        "जीवनावर परिणाम: योग्य-अयोग्य आचरणाचे दिशादर्शन",
        "कार्यरत इंजिनियर व वास्तू-तज्ञ माता-भगिनींची सेवा"
      ]
    },
    motto: "संस्कृतिरेव रक्षति - Culture protects and preserves"
  },
   {
    id: 11,
    name: {
      marathi: "कायदेविषयक सल्लागार विभाग",
      english: "Legal Advisory Department"
    },
    icon: kaydeshirLogo,
    category: "Social",
    color: "#DC2626",
    description: {
      title: "Legal knowledge and family guidance",
      points: [
        "Simplified study of Indian Constitution",
        "Advice on criminal, family and cyber crimes",
        "Creating awareness among women about their rights",
        "Counseling thousands of families to prevent divorce"
      ]
    },
    descriptionMarathi: {
      title: "कायद्याचे ज्ञान आणि कौटुंबिक मार्गदर्शन:",
      points: [
        "भारतीय राज्यघटनेचा सुलभ अभ्यास",
        "गुन्हेगारी, कौटुंबिक व सायबर क्राईमवरील सल्ला",
        "महिलांना त्यांच्या हक्कांची जाणीव करून देणे",
        "घटस्फोट टाळण्यासाठी हजारो कुटुंबांना समुपदेशन"
      ]
    },
    motto: "न्यायं मूलं धर्मस्य - Justice is the foundation of righteousness"
  },
  {
    id: 12,
    name: {
      marathi: "वास्तुशास्त्र विभाग",
      english: "Vastu Shastra Department"
    },
    icon: vastuLogo,
    category: "Cultural",
    color: "#059669",
    description: {
      points: [
        "Clarifying spiritual and scientific importance of Vastu Shastra and providing guidance",
        "Ways to increase positive energy without demolition",
        "Guidance for energy balance for home and village",
        "Geographically compatible, environment-friendly design",
        "Design advice based on scriptural principles",
        "Right and wrong construction: explaining clear differences",
        "Clarifying appropriate-inappropriate effects on life",
        "Service of working engineers and Vastu experts",
        "Demonstrations, consultations and improvement plans",
        "Vastu coordination for healthy, peaceful and prosperous life"
      ]
    },
    descriptionMarathi: {
      points: [
        "वास्तुशास्त्राचे आध्यात्मिक व वैज्ञानिक महत्त्व स्पष्ट करून मार्गदर्शन",
        "तोडफोड-विना सकारात्मक ऊर्जा वाढविण्याचे उपाय",
        "घर व गावासाठी ऊर्जा-संतुलनाचे मार्गदर्शन",
        "भौगोलिक दृष्ट्या सुसंगत, पर्यावरणपूरक रचना",
        "शास्त्रोक्त सिद्धांतांवर आधारित डिझाइन सल्ला",
        "सुयोग्य व चुकीची वास्तू: स्पष्ट फरक समजावणे",
        "जीवनावर होणारे योग्य-अयोग्य परिणाम स्पष्ट करणे",
        "मार्गातील कार्यरत अभियंते व वास्तू-तज्ञांची सेवा",
        "प्रात्यक्षिक, सल्लामसलत व सुधारणा योजना",
        "निरोगी, शांत व समृद्ध जीवनासाठी वास्तु-संयोजन"
      ]
    },
    motto: "वास्तु शास्त्रं सुखाय - Vastu science for happiness"
  },
  {
    id: 13,
    name: {
      marathi: "वेद विज्ञान संशोधन विभाग",
      english: "Vedic Science Research Department"
    },
    icon: vedVidnyanLogo,
    category: "Spiritual",
    color: "#7C2D12",
    description: {
      points: [
        "Reaching scientific explanation of ancient science-Vedas to the public",
        "Ritual-study, scientific research and direct training programs",
        "Explaining the science of mantras-yajnas to encourage raising life standards",
        "Experience-based study on Shrisukta, Purushsukta, Mahamrityunjaya, Pragyavivardhan stotras",
        "Scriptural ritual demonstrations, guidance sessions and workshop organization",
        "Spirituality-science connection; healthy, peaceful, prosperous life through sadhana-treatment"
      ]
    },
    descriptionMarathi: {
      points: [
        "प्राचीन विज्ञान-वेदांचे वैज्ञानिक स्पष्टीकरण जनतेपर्यंत पोहोचवणे",
        "विधी-अभ्यास, वैज्ञानिक अध्ययन व प्रत्यक्ष प्रशिक्षण उपक्रम",
        "मंत्र-यज्ञांचे विज्ञान समजावून जीवनमान उंचावण्यास प्रोत्साहन",
        "श्रीसूक्त, पुरुषसूक्त, महामृत्युञ्जय, प्रज्ञाविवर्धन स्तोत्र यावर अनुभवाधिष्ठित अभ्यास",
        "शास्त्रोक्त विधी प्रात्यक्षिके, मार्गदर्शन सत्रे व कार्यशाळा आयोजन",
        "अध्यात्म-विज्ञान सांगड; साधना-उपचारांद्वारे निरोगी, शांत, समृद्ध जीवनाचा"
      ]
    },
    motto: "यज्ञो वै श्रेष्ठतमं कर्म - Yajna is the highest duty"
  },
  
  {
    id: 14,
    name: {
      marathi: "स्वयंरोजगार विभाग",
      english: "Self-Employment Department"
    },
    icon: swayamRojgarLogo,
    category: "Economic",
    color: "#059669",
    description: {
      title: "Skill development and employment for self-reliance",
      points: [
        "25 employment fairs annually",
        "Employment for 5000+ unemployed",
        "48,000+ registrations",
        "550+ savings groups",
        "Employment for 5500+ women",
        "150+ training workshops"
      ]
    },
    descriptionMarathi: {
      title: "आत्मनिर्भरतेसाठी कौशल्यविकास आणि रोजगार:",
      points: [
        "दरवर्षी 25 रोजगार मेळावे",
        "5000+ बेरोजगारांना रोजगार",
        "48,000+ नावनोंदणी",
        "550+ बचत गट",
        "5500+ महिलांना रोजगार",
        "150+ प्रशिक्षण कार्यशाळा"
      ]
    },
    motto: "स्वावलंबनं परमं धर्मः - Self-reliance is the highest duty"
  },
   {
    id: 15,
    name: {
      marathi: "प्रशिक्षण विभाग",
      english: "Training Department"
    },
    icon: prashikshanLogo,
    category: "Education",
    color: "#7C3AED",
    description: {
      points: [
        "Free training and guidance for those willing to serve in departments voluntarily",
        "Equal opportunity for all, clear criteria and consistent process",
        "Structured training, code of conduct and work procedures",
        "Workshops, gatherings, live demonstrations and mentoring by experienced service workers",
        "Assignment to appropriate department after skill mapping"
      ]
    },
    descriptionMarathi: {
      points: [
        "इच्छुकांना स्वेच्छेने विभागात सेवेसाठी विनामूल्य प्रशिक्षण व मार्गदर्शन.",
        "सर्वांसाठी समान संधी, स्पष्ट निकष आणि सुसंगत प्रक्रिया.",
        "संरचित प्रशिक्षण, आचारसंहिता व कार्यपद्धती",
        "कार्यशाळा, मेळावे, प्रत्यक्ष प्रात्यक्षिके व अनुभवी सेवेकऱ्यांचे मेंटरिंग",
        "कौशल्य-मॅपिंगनंतर योग्य विभागात नियुक्ती."
      ]
    },
    motto: "प्रशिक्षणं सर्वोत्तमं - Training is the best"
  },

   {
    id: 16,
    name: {
      marathi: "पर्यावरण व प्रकृती विभाग",
      english: "Environment & Nature Department"
    },
    icon: parayvanLogo,
    category: "Environment",
    color: "#16A34A",
    description: {
      title: "Programs for green and sustainable future",
      points: [
        "1 lakh+ tree plantation and conservation",
        "250+ plate banks for plastic and thermocol-free programs",
        "Environment-friendly Ganesh Festival and clay idol promotion",
        "E-crackers: Programs to prevent noise and air pollution",
        "Pollution-free Diwali programs"
      ],
      special: "Fort conservation: Cleanliness campaigns on historical forts, temple respect, biodiversity conservation"
    },
    descriptionMarathi: {
      title: "हरित आणि शाश्वत भविष्यासाठी उपक्रम:",
      points: [
        "1 लाख+ वृक्षारोपण व संवर्धन",
        "प्लास्टिक व थर्माकोलविरहित कार्यक्रमांसाठी 250+ प्लेट बँक",
        "'पर्यावरणपूरक गणेशोत्सव' व मातीच्या मूर्ती प्रचार-प्रसार",
        "ई-फटाके: ध्वनी व वायू प्रदूषण टाळण्यासाठी उपक्रम",
        "प्रदूषणमुक्त दिवाळी उपक्रम"
      ],
      special: "दुर्ग संवर्धन: ऐतिहासिक गडकोटांवर स्वच्छता मोहीम, देवस्थानांचा सन्मान, जैवविविधतेचे संवर्धन."
    },
    motto: "प्रकृतिरेव रक्षति - Nature protects us"
  },
  
  {
    id: 17,
    name: {
      marathi: "प्रशासकीय विभाग",
      english: "Administrative Department"
    },
    icon: prashasakiyaLogo,
    category: "Administrative",
    color: "#64748B",
    description: {
      points: [
        "Monthly Satsang: Every fourth Saturday, guidance meeting of service workers at Tryambakeshwar",
        "National Satsang: Organization and management of nationwide satsangs by Gurumauli",
        "Coordination: Planning, reporting system and SOP compliance",
        "Communication: Circulars, training, and clear guiding principles",
        "Benefit: Reaching spiritual and social service direction to all service workers"
      ]
    },
    descriptionMarathi: {
      points: [
        "मासिक सत्संग: प्रत्येक चौथ्या शनिवारी, त्र्यंबकेश्वर येथे सेवेकऱ्यांची मार्गदर्शन भेट",
        "राष्ट्रीय सत्संग: गुरुमाऊलींच्या राष्ट्रव्यापी सत्संगांचे आयोजन व व्यवस्थापन",
        "समन्वय: नियोजन, अहवालपद्धती व मानक कार्यपद्धती (SOP) पालन",
        "संवाद: सूचनापत्रे, प्रशिक्षण, आणि स्पष्ट मार्गदर्शक तत्त्वे",
        "लाभ: सर्व सेवेकऱ्यांपर्यंत आध्यात्मिक व सामाजिक सेवेची दिशा पोहोचवणे"
      ]
    },
    motto: "प्रशासनं सुव्यवस्थितं - Well-organized administration"
  },
  
  {
    id: 18,
    name: {
      marathi: "देश-विदेश विभाग",
      english: "National & International Department"
    },
    icon: deshVideshLogo,
    category: "Outreach",
    color: "#1D4ED8",
    description: {
      points: [
        "Without discrimination of caste, religion, sect, liberating deprived and suffering society from sorrow towards joyful, peaceful life",
        "Promotion and propagation of service path throughout India and abroad",
        "Studying social, geographical and spiritual aspects of each region and creating effective public awareness through harmony with locals"
      ]
    },
    descriptionMarathi: {
      points: [
        "जात, धर्म, पंथ भेद न करता वंचित, पीडित समाजाला दुःखातून मुक्त करून आनंदी, शांत जीवनाकडे नेणे.",
        "संपूर्ण भारतासह परदेशातही सेवा मार्गाचा प्रचार प्रसार",
        "प्रत्येक प्रदेशाचा सामाजिक, भौगोलिक व आध्यात्मिक अभ्यास करून स्थानिकांशी सुसंवाद साधत प्रभावी जनजागृती."
      ]
    },
    motto: "वसुधैव कुटुम्बकं - The Global is one family"
  },
 
];

export const categories = [
  { id: 'all', name: 'All Departments', color: '#6B7280' },
  { id: 'Economic', name: 'Economic', color: '#059669' },
  { id: 'Cultural', name: 'Cultural', color: '#8B5CF6' },
  { id: 'Technology', name: 'Technology', color: '#0EA5E9' },
  { id: 'Environment', name: 'Environment', color: '#16A34A' },
  { id: 'Agriculture', name: 'Agriculture', color: '#F59E0B' },
  { id: 'Animal Welfare', name: 'Animal Welfare', color: '#CA8A04' },
  { id: 'Social', name: 'Social', color: '#DC2626' },
  { id: 'Education', name: 'Education', color: '#7C3AED' },
  { id: 'Health', name: 'Health', color: '#10B981' },
  { id: 'Spiritual', name: 'Spiritual', color: '#7C2D12' },
  { id: 'Outreach', name: 'Outreach', color: '#1D4ED8' },
  { id: 'Administrative', name: 'Administrative', color: '#64748B' }
];